function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.0002,
  r: 12,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9924 19.5699V12.924H15.2601L15.5997 10.334H12.9924V8.68033C12.9924 7.93045 13.2041 7.41942 14.2973 7.41942L15.6915 7.41882V5.10234C15.4503 5.07077 14.6227 5.00024 13.6599 5.00024C11.6497 5.00024 10.2735 6.20725 10.2735 8.42391V10.334H8V12.924H10.2735V19.5699H12.9924Z",
  fill: "#ED0F77"
});

var SvgFbPink = function SvgFbPink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFbPink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fb-pink.400c7676.svg";
export { ForwardRef as ReactComponent };